import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { EventService } from 'src/app/core/services/event.service';
import { environment } from 'src/environments/environment';
import { createS3Client, createCognitoCredentials, createUpload } from '../utils/aws-s3.util';
import { ToastService } from '../core/services/toast.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BrandingProgressDialogComponent } from './branding-progress-dialog/branding-progress-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../shared/confirmation-modal/confirmation-modal.component';
import { LogToS3Service } from '../core/services/log.service';
import { reloadApp } from '../core/utils/reload-app';
@Component({
  selector: 'app-add-branding',
  templateUrl: './add-branding.component.html',
  styleUrls: ['./add-branding.component.css'],
  //standalone: true,
  //imports: [ConfirmationModalComponent]
})
export class AddBrandingComponent {
  brandingEnabled: boolean = false;
  brandingSaved: boolean = false;
  isEditMode: boolean = false;
  brandingText: string = '';
  brandingPosition: string = 'bottom-right';
  logoUrl: string | null = null;
  logoFile: File | null = null; // store actual file for API
  private identityPoolId: string = environment.aws.IdentityPoolId;
  
  // Original values to track changes
  originalBrandingEnabled: boolean = false;
  originalBrandingText: string = '';
  originalBrandingPosition: string = 'bottom-right';
  originalLogoUrl: string | null = null;
  originalPrevLogo: any = null;
  
  positions = [
    { label: 'Top Left', value: 'top-left' },
    { label: 'Top Right', value: 'top-right' },
    { label: 'Bottom Left', value: 'bottom-left' },
    { label: 'Bottom Right', value: 'bottom-right' },
    { label: 'Center', value: 'center' }
  ];
  confirmMessage = "'Are you sure you want to delete the selected file(s)?'"
  showConfirmModal = false;
  pendingBrandingChange: boolean = false;
  defaultLandscape = 'assets/default-landscape.jpg'; // add in assets folder
  defaultPortrait = 'assets/default-portrait.jpg';   // add in assets folder
  eventId: any;
  eventName: any;
  getBranding: boolean = false;
  isLoading: boolean = false;
  viewer_hash: any;
  prevLogo: any = null
  brandingUpdated: boolean = false;
  polling: NodeJS.Timeout | undefined;
  progress = 0;
  progressStatus: 'pending' | 'processing' | 'done' = 'pending';

  constructor(private eventService: EventService, public fbAuth: AngularFireAuth,
    private toastService: ToastService, private router: Router, private bar: MatSnackBar, private dialog: MatDialog,
    private loggingService: LogToS3Service
  ) { }

  ngOnDestroy() {
    if (this.polling) clearInterval(this.polling);
  }

  async ngOnInit() {

    this.brandingUpdated = false;
    this.eventId = localStorage.getItem('e');
    this.eventName = localStorage.getItem('name');
    this.getBranding = localStorage.getItem('branding') === 'true';

    if (this.getBranding) {
      this.brandingEnabled = true;
      this.originalBrandingEnabled = true; // Store initial state
      await this.fetchBrandingData();
      this.brandingSaved = true;
      this.isEditMode = false;
    } else {
      this.brandingEnabled = false;
      this.originalBrandingEnabled = false; // Store initial state
      this.isEditMode = true;
    }
  }

  enableEditMode() {
    this.isEditMode = true;
  }

  cancelEdit() {
    if (this.getBranding) {
      // Restore original values including branding toggle
      this.brandingEnabled = this.originalBrandingEnabled;
      this.brandingText = this.originalBrandingText;
      this.brandingPosition = this.originalBrandingPosition;
      this.logoUrl = this.originalLogoUrl;
      this.prevLogo = this.originalPrevLogo;
      this.logoFile = null;
      this.isEditMode = false;
    } else {
      // If no branding was set, go back
      this.goBack();
    }
  }

  triggerFileInput() {
    const fileInput = document.getElementById('logoInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  async fetchBrandingData() {
    this.brandingUpdated = false;
    this.isLoading = true;
    (await this.eventService.getBrandingData(this.eventId)).subscribe({
      next: (data: any) => {
        let res = data?.result;
        if (res) {
          // console.log('Branding data fetched:', data); //__CONSOLE_LOG__ //__CONSOLE_LOG__
          //this.brandingEnabled = data.enabled ?? false;
          this.brandingText = res.text ?? '';
          this.brandingPosition = res.position ?? 'bottom-right';
          this.logoUrl = res.logoUrl ?? null;
          this.viewer_hash = res.viewer_hash ?? null;
          
          this.prevLogo = res.logo ?? null;
          
          // Store original values (but don't overwrite originalBrandingEnabled as it's set in ngOnInit)
          this.originalBrandingText = this.brandingText;
          this.originalBrandingPosition = this.brandingPosition;
          this.originalLogoUrl = this.logoUrl;
          this.originalPrevLogo = this.prevLogo;
        }
        this.isLoading = false;
      },
      error: (err: any) => {
        // console.error('Failed to fetch branding data:', err); //__CONSOLE_LOG__
        this.isLoading = false;
      }
    });
  }


  onLogoSelected1(event: Event) {
    const input = event.target as HTMLInputElement;
    this.prevLogo = null; // reset previous logo if new logo is selected
    if (input.files && input.files.length > 0) {
      this.logoFile = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.logoUrl = reader.result as string;
      };
      reader.readAsDataURL(this.logoFile);
    }
  }

  onLogoSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    this.prevLogo = null; // reset previous logo if new logo is selected

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // ✅ File size restriction (e.g., 500KB)
      const maxFileSize = 500 * 1024; // 500 KB
      if (file.size > maxFileSize) {
        alert(`Logo file is too large. Maximum size is 500KB.`);
        input.value = ''; // reset input
        return;
      }

      // ✅ Dimension restriction (e.g., 800x800px)
      const maxWidth = 800;
      const maxHeight = 800;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = () => {
          if (img.width > maxWidth || img.height > maxHeight) {
            alert(`Logo dimensions too large. Maximum allowed is ${maxWidth}x${maxHeight}px.`);
            input.value = ''; // reset input
            return;
          }

          // ✅ Valid logo: save file and preview
          this.logoFile = file;
          this.logoUrl = e.target.result as string;
        };
      };

      reader.readAsDataURL(file);
    }
  }


  goBack() {
    localStorage.removeItem('e');
    localStorage.removeItem('name');
    localStorage.removeItem('branding');
    localStorage.removeItem('viewer_hash');
    if (localStorage.getItem('manageEventReturn') === 'true') {
      localStorage.removeItem('manageEventReturn');
      this.router.navigateByUrl('/manage-event');
    } else {
      localStorage.removeItem('eventId');
      this.router.navigateByUrl('/branding-settings');
    }
  }

  removeLogo() {
    this.logoFile = null;
    this.logoUrl = null;
    this.prevLogo = null;
  }

  async uploadLogo(eventId: any, file: any, fileName: string): Promise<any> {
    const currentUser = await this.fbAuth.currentUser;
    if (!currentUser) {
      throw new Error("No authenticated user found.");
    }
    const firebaseToken = await currentUser.getIdToken(true);
    const region = 'us-west-1';
    const s3 = await createS3Client({
      region,
      credentials: await createCognitoCredentials({
        identityPoolId: this.identityPoolId,
        logins: {
          'securetoken.google.com/picaggo-235807': firebaseToken
        },
        clientConfig: { region }
      })
    });
    //let fileName = file.name.split('.').slice(0, -1).join('.') + '-' + Date.now();

    const params = {
      Bucket: environment.aws.bucketName,
      Key: "events/" + eventId + "/branding/logo/" + fileName,
      Body: file,
      //Metadata: metadata
    };
    const upload = await createUpload({ client: s3, params });

    try {
      const data = await upload.done();
      return data;
    } catch (error) {
      // Must rethrow: proceedWithSave writes this file name into the branding
      // record, so a swallowed failure here leaves the DB pointing at a logo
      // that was never uploaded.
      this.loggingService.logError(`Branding logo upload failed for ${fileName}`, error);
      throw error instanceof Error ? error : new Error(String(error));
    }
  }

  goToEventGallery() {
    // this.bar.open('Branding in progress... Branded images will appear soon.', 'Dismiss', {
    //   duration: 5000,
    // });
    if (this.brandingUpdated) {
      this.showToast('Watermarking in progress... updated images will appear soon.');
    } this.router.navigate(['/event-detail/true']).then(() => {
      reloadApp('branding_saved');
    });
  }

  editBranding() {
    this.brandingSaved = false;
    this.isEditMode = true;
  }

  hasChanges(): boolean {
    // Check if branding enabled state changed
    if (this.brandingEnabled !== this.originalBrandingEnabled) {
      return true;
    }
    
    // Check if text changed
    if (this.brandingText !== this.originalBrandingText) {
      return true;
    }
    
    // Check if position changed
    if (this.brandingPosition !== this.originalBrandingPosition) {
      return true;
    }
    
    // Check if a new logo file was selected
    if (this.logoFile !== null) {
      return true;
    }
    
    // Check if logo was removed
    if (this.prevLogo !== this.originalPrevLogo) {
      return true;
    }
    
    return false;
  }

  async saveBranding() {
    // Check if there are any changes
    if (!this.hasChanges()) {
      this.showToast('No changes detected. Nothing to save.');
      return;
    }
    
    // Show confirmation before starting the watermarking process
    this.showConfirmModal = true;
    this.confirmMessage = "Once the watermarking process starts, it cannot be stopped in between. Please make sure everything looks right before you continue. ";
  }

  async proceedWithSave() {
    this.brandingUpdated = true;
    this.isLoading = true;
    this.eventId = localStorage.getItem('e');
    let _fileName: string | null = null;
    if (this.logoFile && this.prevLogo == null) {
      _fileName = this.logoFile.name.split('.')[0] + '-' + Date.now() + '.' + this.logoFile.name.split('.')[1];
      // Must await and must not continue on failure: saveBrandingData below
      // records _fileName as the event's logo, so saving after a failed upload
      // points the event at an object that isn't in the bucket. Previously this
      // was fire-and-forget with a swallowed error, so it did exactly that.
      try {
        await this.uploadLogo(this.eventId, this.logoFile, _fileName);
      } catch (error) {
        this.isLoading = false;
        this.brandingUpdated = false;
        this.showToast('Logo upload failed. Please check your connection and try again.');
        return;
      }
    }

    if (this.brandingEnabled == false) {
      this.logoFile = null;
      this.logoUrl = null;
      _fileName = null;
      this.prevLogo = null;
      this.brandingText = '';
    }

    (await this.eventService.saveBrandingData(this.eventId, this.brandingText, _fileName, this.brandingPosition, this.prevLogo, this.brandingEnabled)).subscribe(
      (response: any) => {
        // console.log('Branding save response:', response); //__CONSOLE_LOG__ //__CONSOLE_LOG__
        this.isLoading = false;
        this.showToast('Watermarking settings saved successfully!');
        if (response.result.file_count > 0) {
          const dialogRef = this.dialog.open(BrandingProgressDialogComponent, {
            width: '400px',
            data: { eventId: this.eventId },
            disableClose: true,
            backdropClass: 'secondary-backdrop',
            panelClass: 'progress-dialog',
            hasBackdrop: true
          });

          dialogRef.afterClosed().subscribe(() => {
            this.brandingSaved = true;
            this.isEditMode = false;
            this.updateOriginalValues();
          });
        }
        this.brandingSaved = true;
        this.isEditMode = false;
        this.updateOriginalValues();
        localStorage.setItem('branding', this.brandingEnabled.toString());
        // console.log('Form submitted successfully', response); //__CONSOLE_LOG__ //__CONSOLE_LOG__ //__CONSOLE_LOG__
      },
      (error: any) => {
        this.isLoading = false;
        this.showToast('Error submitting form');
        // console.error('Error submitting form', error); //__CONSOLE_LOG__ //__CONSOLE_LOG__ //__CONSOLE_LOG__
      }
    );

  }

  updateOriginalValues() {
    // Update original values after successful save
    this.originalBrandingEnabled = this.brandingEnabled;
    this.originalBrandingText = this.brandingText;
    this.originalBrandingPosition = this.brandingPosition;
    this.originalLogoUrl = this.logoUrl;
    this.originalPrevLogo = this.prevLogo;
    this.logoFile = null; // Reset the file after save
  }

  showToast(message: any) {
    this.toastService.showToast(message);
  }


  async onBrandingToggle(event: any) {
    const isChecked = event.target.checked;
    
    if (!isChecked) {
      // User wants to disable watermarking - show confirmation
      this.showConfirmModal = true;
      this.confirmMessage = "You are about to disable watermarking. This will remove the watermark from your event images. Are you sure you want to proceed?";
    } else {
      // User wants to enable watermarking
      this.brandingEnabled = true;
      await this.fetchBrandingData();
    }
  }


  onChangeConfirmed(confirmed: any) {
    this.showConfirmModal = false;
    
    if (!confirmed) {
      // User clicked cancel - revert the toggle
      if (this.confirmMessage.includes("disable watermarking")) {
        this.brandingEnabled = true;
      }
      return;
    }

    // User clicked confirm
    if (this.confirmMessage.includes("Once the watermarking process starts")) {
      // Save confirmation
      this.proceedWithSave();
    } else if (this.confirmMessage.includes("disable watermarking")) {
      // Disable watermarking confirmation
      this.brandingEnabled = false;
      this.logoFile = null;
      this.logoUrl = null;
      this.prevLogo = null;
      this.brandingText = '';
      this.proceedWithSave();
    }
  }

  onCancel(event: any) {
    this.showConfirmModal = false;
    
    // Revert the toggle if user was trying to disable watermarking
    if (this.confirmMessage.includes("disable watermarking")) {
      this.brandingEnabled = true;
    }
    
    event?.stopPropagation();
  }
}

